import project1 from '../Utils/Screenshot 2023-08-31 163253.png'
import project2 from '../Utils/Screenshot 2023-08-31 163938.png'
import project3 from '../Utils/Screenshot 2023-08-31 164913.png'
import project4 from '../Utils/Screenshot 2024-06-09 141451.png'

export const projects = [
	{
		img: project1,
		title: 'E-Commerce Store',
		des: 'An e-commerce website for electronic products.',
		live: 'https://e-tech-store.onrender.com/',
		gitHub: 'https://github.com/aashishthakurcodes/E-CART',
		technologies:['React.js','Express JS,','MongoDB,',"Mongoose,",'antDesign,',"Bootstrap"],
	},
	{
		img: project2,
		title: 'Expense Manager',
		des: 'Take control of your finances with ExpenseWise, the smart solution for managing your expenses. From tracking daily spends to setting budget goals ',
		live: 'https://expense-manager-3qx2.onrender.com/',
		gitHub: 'https://github.com/aashishthakurcodes/EXPENSE_MANAGER',
		technologies: ['JavaScript,',"HTML," ,'CSS,',"MERN,","antDesign,","BootStrap"],
	},
	{
		img: project3,
		title: 'Stone Paper Scissor Game',
		des: 'A simple Stone Paper and Scissor game.Make your selections carefully, as stone, paper, and scissors vie for supremacy in this classic gesture warfare.',
		live: 'https://fsjs-2-0-react-project.vercel.app/',
		gitHub: 'https://github.com/aashishthakurcodes/FSJS_2.0_REACT_PROJECT',
		technologies: [ 'HTML,', 'CSS,','and', 'JavaScript'],
	},
	{
		img: project4,
		title: 'Super Charged || NEXT',
		des: 'A simple Next.js project with a beautiful UI using Acceternity UI.',
		live: 'https://nextjssupercharged-9379286g0-j9183208gmailcoms-projects.vercel.app/',
		gitHub: 'https://github.com/aashishthakurcodes/nextjs',
		technologies: [ 'Next.Js','Accertinity Ui'],
	}
];
